// defs
import { CampaignAdType } from '@local/typedefs/dist/protos/campaign/Campaign';
import { AdUnitType, } from '@local/typedefs/dist/shaped/campaign/Campaign';
export const STORE_KEY = '__WRITE_CAMPAIGN_DETAILS__';
export var CampaignWriteModeEnum;
(function (CampaignWriteModeEnum) {
    CampaignWriteModeEnum["CREATE"] = "create";
    CampaignWriteModeEnum["EDIT"] = "edit";
    CampaignWriteModeEnum["DUPLICATE"] = "duplicate";
    CampaignWriteModeEnum["DRAFT"] = "draft";
})(CampaignWriteModeEnum || (CampaignWriteModeEnum = {}));
export const getAdGroupInitialState = (adUnitType = AdUnitType.PRODUCT) => ({
    keywords: [],
    unitType: adUnitType,
    cityIds: [],
    mealSlots: [],
    daysOfWeek: [],
    candidates: [],
});
export const INITIAL_STATE = {
    name: '',
    startDate: '',
    endDate: '',
    budget: 0,
    pacingEnabled: false,
    type: CampaignAdType.CAMPAIGN_AD_TYPE_SPONSORED_PRODUCT,
    placementIds: [],
    createdBy: '',
    updatedBy: '',
    adGroups: [Object.assign({}, getAdGroupInitialState())],
    biddingStrategy: 'cpm',
    cityIds: [],
    validationMessages: {},
};
